module.exports = __webpack_public_path__ + "static/media/04FreshPreservesinnersleeve.328f74aa.webp";